import { useState, useEffect } from 'react';

import { useQuery } from '@apollo/client';
import { Tooltip } from 'react-tooltip';
import { getUsernameFromToken } from 'utils/authUtils';
import {
  GetUserPermissions,
  GetUserPermissionsVariables,
} from 'query/__generated__/permissionsQueries';
import { GET_USER_PERMISSIONS } from 'query/permissionsQueries';

import ChangePasswordForm from './ChangePasswordForm';

import './Security.scss';

const Security = () => {
  const [changingPassword, setChangingPassword] = useState(false);
  const [currentUsername, setCurrentUsername] = useState<string | null>(null);
  const [isCurrentUserNative, setIsCurrentUserNative] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;
    getUsernameFromToken()
      .then((username) => {
        if (isMounted) {
          setCurrentUsername(username);
        }
      })
      .catch(() => {
        // Ignore errors
      });
    return () => {
      isMounted = false;
    };
  }, []);

  const { data: currentUserData } = useQuery<GetUserPermissions, GetUserPermissionsVariables>(
    GET_USER_PERMISSIONS,
    {
      variables: {
        requestData: { username: currentUsername || '' },
      },
      skip: !currentUsername,
      fetchPolicy: 'cache-first',
    },
  );

  useEffect(() => {
    const userType = (currentUserData?.userManagementGetUser?.user as any)?.userType;
    // Enable button only if user is native (not SSO)
    // Default to true (enabled) if userType is not available yet
    if (userType) {
      setIsCurrentUserNative(userType === 'NATIVE' || userType === null || userType === undefined);
    } else {
      // If we don't have userType yet, default to enabled (assume native until we know otherwise)
      setIsCurrentUserNative(true);
    }
  }, [currentUserData]);

  return (
    <div className="account__security">
      <table>
        <tbody>
          <tr>
            <td className="heading" colSpan={changingPassword ? 2 : 1}>
              Password
              {changingPassword && <ChangePasswordForm setIsOpen={setChangingPassword} />}
            </td>
            {!changingPassword && (
              <td className="value">
                <div className="account__security__masked__password">
                  <span>••••••••••</span>
                  {!isCurrentUserNative && (
                    <Tooltip id="sso-password-disabled-tooltip" place="top" variant="info">
                      <span>Password changes are managed by your SSO provider.</span>
                    </Tooltip>
                  )}
                  <button
                    className="account__security__password"
                    type="button"
                    onClick={() => setChangingPassword(true)}
                    disabled={!isCurrentUserNative}
                    data-tooltip-id={
                      !isCurrentUserNative ? 'sso-password-disabled-tooltip' : undefined
                    }
                    style={{
                      cursor: !isCurrentUserNative ? 'not-allowed' : 'pointer',
                      opacity: !isCurrentUserNative ? 0.5 : 1,
                    }}
                  >
                    Change
                  </button>
                </div>
              </td>
            )}
          </tr>
          {/*
          <tr>
            <td className='heading'>2-Step Verification</td>
            <td className='value'>
              <ToggleButton checkedLabel="On" uncheckedLabel="Off" />
            </td>
          </tr>
          <tr>
            <td className='heading'>Auto logout</td>
            <td className='value'>
              <ToggleButton checkedLabel="On" uncheckedLabel="Off" />
            </td>
          </tr>
          */}
        </tbody>
      </table>
    </div>
  );
};

export default Security;
